// extracted by mini-css-extract-plugin
export default {"loginBg":"login_loginBg__Cl98J","version":"login_version__TsRV0"};